import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'iposcen-ipos-help-uninstallation-package',
  templateUrl: './ipos-help-uninstallation-package.component.html',
  styleUrls: ['./ipos-help-uninstallation-package.component.scss']
})
export class IposHelpUninstallationPackageComponent implements OnInit {
  @Output() readonly sideNav = new EventEmitter();
  @Input() sideNavData;
  @ViewChild('uninstallIposThroughOda') uninstallIposThroughOda: ElementRef;
  @ViewChild('uninstallIposFromDesktop') uninstallIposFromDesktop: ElementRef;
  @ViewChild('uninstallIposFromCdrive') uninstallIposFromCdrive: ElementRef;
  @ViewChild('uninstallIposFromControlPanel') uninstallIposFromControlPanel: ElementRef;
  @ViewChild('deleteDemoAccount') deleteDemoAccount: ElementRef;
  @ViewChild('deleteIposFolder') deleteIposFolder: ElementRef;
  @ViewChild('changeWindowsPassword') changeWindowsPassword: ElementRef;
  @ViewChild('removalOfIpos') removalOfIpos: ElementRef;
  isUninstallIposThroughOda = true;
  isUninstallIposFromDesktop = true;
  isUninstallIposFromCdrive = true;
  isUninstallIposFromControlPanel = true;
  isDeleteDemoAccount = true;
  isDeleteIposFolder = true;
  isChangeWindowsPassword = true;
  isRemovalOfIpos = true;
  

  constructor() { }

  ngOnInit(): void {
  }

  change(data) {
    if (data === 'uninstallIposThroughOda') {
      setTimeout(() => {
        this.uninstallIposThroughOda.nativeElement.scrollIntoView();
      }, 0);
    } else if (data === 'uninstallIposFromDesktop') {
      setTimeout(() => {
        this.uninstallIposFromDesktop.nativeElement.scrollIntoView();
      }, 0);
    } else if (data === 'uninstallIposFromCdrive') {
      setTimeout(() => {
        this.uninstallIposFromCdrive.nativeElement.scrollIntoView();
      }, 0);
    } else if (data === 'uninstallIposFromControlPanel') {
      setTimeout(() => {
        this.uninstallIposFromControlPanel.nativeElement.scrollIntoView();
      }, 0);
    } else if (data === 'deleteDemoAccount') {
      setTimeout(() => {
        this.deleteDemoAccount.nativeElement.scrollIntoView();
      }, 0);
    } else if (data === 'deleteIposFolder') {
      setTimeout(() => {
        this.deleteIposFolder.nativeElement.scrollIntoView();
      }, 0);
    } else if (data === 'changeWindowsPassword') {
      setTimeout(() => {
        this.changeWindowsPassword.nativeElement.scrollIntoView();
      }, 0);
    } else if (data === 'removalOfIpos') {
      setTimeout(() => {
        this.removalOfIpos.nativeElement.scrollIntoView();
      }, 0);
    } 
  }

  showDescription(data) {
    
    if(data === 'uninstallIposThroughOda'){
      this.isUninstallIposThroughOda = !this.isUninstallIposThroughOda;
    }else if (data === 'uninstallIposFromDesktop'){
      this.isUninstallIposFromDesktop = !this.isUninstallIposFromDesktop;
    } else  if (data === 'uninstallIposFromCdrive'){
      this.isUninstallIposFromCdrive = !this.isUninstallIposFromCdrive;
    } else if(data === 'uninstallIposFromControlPanel'){
      this.isUninstallIposFromControlPanel = !this.isUninstallIposFromControlPanel;
    } else if(data === 'deleteDemoAccount'){
      this.isDeleteDemoAccount = !this.isDeleteDemoAccount;
    } else if(data === 'deleteIposFolder'){
      this.isDeleteIposFolder = !this.isDeleteIposFolder;
    } else if(data === 'changeWindowsPassword'){
      this.isChangeWindowsPassword = !this.isChangeWindowsPassword;
    } else if(data === 'removalOfIpos'){
      this.isRemovalOfIpos = !this.isRemovalOfIpos;
    } 
  }


}
